export enum AppLookupTableKeys {
  AppFeatureLookup = 'App Feature Lookup',
  CountryCodeLookup = 'Country Code Lookup',
  InstitutionTypeLookup = 'Institution Type Lookup',
  UserRoleLookup = 'User Roles Lookup',
  RolePermissionLookup = 'Permissions Lookup',
}
